import React from 'react'
import './Spiritual_Truth_Card.css'
import { useNavigate } from 'react-router-dom'

const Spiritual_Truth_Card = ({ img, label, goto }) => {

  const navigate = useNavigate()

  return (
    <section className='Spiritual_Truth_Card' onClick={() => { navigate(goto) }}>
      <div className='img_holder'>
        <img src={process.env.PUBLIC_URL + img} className='card_img' />
      </div>
      <p className='label_text'>{label}</p>
      <div className='pink_overlay'></div>
    </section>
  )
}

export default Spiritual_Truth_Card
